<ng-container>
	<div class="quantity-field-div">
		<mat-form-field subscriptSizing="dynamic" floatLabel="always" class="quantity-input-field">
			<mat-label translate>offers.wizard.stepper.step.quantity</mat-label>
			<input matInput type="number" copoInputNumber
				[min]="1" [decimalCount]="0" [formControl]="qtyControl"
				(change)="quantityOnChange()">
			<mat-icon matSuffix class="pencil-icon" svgIcon="copo_pencil"></mat-icon>
		</mat-form-field>
	</div>
</ng-container>